import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import UserImage from "../../assets/user.png"
import Loader from '../../components/Loader'
import { FaSearch } from "react-icons/fa"

const SuggestedFriends = () => {
    const [suggestedFriends, setSuggestedFriends] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(false)

    useEffect(() => {
        const getSuggestedFriends = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/community/friends/suggesteds?page=${page}`)
                if (response) {
                    setIsLoading(false)
                    setSuggestedFriends(response?.data.friends)
                    setHasMore(!response.data.hasmore)
                }
                else {
                    toast.error("Error getting suggested friends")
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data?.message)
            }
        }
        getSuggestedFriends()
    }, [])

    const handleRefresh = () => { }

    const addFriend = async (id) => {
        try {
            const response = await api.post("/community/friends/requests", {friend:id});
            if (response.status === 200) {
                toast.success("Friend request sent");
                setSuggestedFriends((suggestedFriends) =>
                    suggestedFriends.filter((friend) => friend._id !== id)
                );
            }
        } catch (error) {
            toast.error("Failed to send friend request");
        }

    }
    return (
        <div className='users-page-container'>
            <h2 className="users-list-header">Suggested Friends</h2>
            <form className="suggested-friends-search-form">
                <input type="text" />
                <button><FaSearch /></button>
            </form>
            <InfiniteScroll
                dataLength={suggestedFriends.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="users-container">
                    {isLoading && <Loader />}
                    {!isLoading && suggestedFriends.length === 0 &&
                        <p className="not-found-msg">No suggested friends found</p>
                    }
                    {
                        suggestedFriends && suggestedFriends.map((frd) => (
                            <div className='user-action-card' key={frd._id}>
                                <div className="user-action-card-details">
                                    <img src={frd.profilePic.url ? frd.profilePic.url : UserImage} alt="" />
                                    <div className="action-card-buttons">
                                        <p className="user-names">{frd.firstname} {frd.lastname}</p>
                                        <button onClick={() => addFriend(frd._id)}>Add</button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                {
                    isLoading && <Loader />
                }
            </InfiniteScroll>
        </div>
    )
}

export default SuggestedFriends